// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","link":"Footer_link__sgKeT","title":"Footer_title__xdj5Y"};